module.exports = __webpack_public_path__ + "static/media/xuqianhetong.d394604c.png";